import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Navbar, Nav } from "react-bootstrap";
import classNames from "classnames";
import Logo from "components/common/Logo";
import { navbarBreakPoint, topNavbarBreakpoint } from "config";
import TopNavRightSideNavItem from "components/navbar/top/TopNavRightSideNavItem";
import { useAppContext } from "providers/AppProvider";

const NavbarTopHorus = () => {
  const {
    config: { showBurgerMenu, navbarCollapsed },
    setConfig,
  } = useAppContext();

  const [showDropShadow, setShowDropShadow] = useState(false);

  const handleBurgerMenu = () => {
    setConfig("showBurgerMenu", !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", setDropShadow);
    return () => window.removeEventListener("scroll", setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  return (
    <Navbar
      className={classNames("navbar-glass fs-10 navbar-top sticky-kit", {
        // 'navbar-glass-shadow': showDropShadow
        "navbar-glass-shadow": showDropShadow,
      })}
      expand={true}
    >
      <NavbarTopElements
        handleBurgerMenu={handleBurgerMenu}
        burgerMenuRef={burgerMenuRef}
      />
    </Navbar>
  );
};

const NavbarTopElements = ({ handleBurgerMenu }) => {
  const burgerMenuRef = useRef();
  const environment = import.meta.env.VITE_REACT_APP_ENVIRONMENT;
  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={`toggle-icon-wrapper me-md-3 me-2 d-${navbarBreakPoint}-none`}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <Logo at="navbar-top" textClass="text-primary" name="Horus" />

      {
        <Nav
          navbar
          className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}
          as="ul"
        ></Nav>
      }
      {environment === "Staging" && (
        <span className="badge rounded-pill badge-subtle-warning fs-10">
          Staging
        </span>
      )}
      {environment === "Development" && (
        <span className="badge rounded-pill badge-subtle-success fs-10">
          Dev
        </span>
      )}
      {environment === "Local" && (
        <span className="badge rounded-pill badge-subtle-info fs-10">
          Local
        </span>
      )}
      <TopNavRightSideNavItem />
    </>
  );
};

NavbarTopElements.propTypes = {
  handleBurgerMenu: PropTypes.func,
};
export default NavbarTopHorus;
